import { ChangeDetectorRef, Component, Input } from "@angular/core";

import { SvgIconComponent } from "app/modules/shared/svg-icon/svg-icon.component";

@Component({
  selector: "app-google-stars",
  imports: [SvgIconComponent],
  templateUrl: "./google-stars.component.html",
  styleUrls: ["./google-stars.component.scss"],
})
export class GoogleStarsComponent {
  @Input("rating") rating: string;
  wholeStars: number;
  starArray = [];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.initRating();
    this.cdr.detectChanges();
  }

  initRating() {
    this.wholeStars = parseInt(this.rating.slice(5, 6));
    for (let i = 0; i < this.wholeStars; i++) {
      this.starArray.push("google-star");
    }
    if (this.rating.slice(7, 8) === "5") {
      this.starArray.push("google-star-not-full");
    }
  }
}
